import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable, throwError } from 'rxjs';
import StsA360RegStep1AnswersModel from '../models/sts-a360-reg-step1-answers.model';
import StsA360RegStep1QuestionsModel from '../models/sts-a360-reg-step1-questions.model';
import StsA360RegStep2UsernamePostModel from '../models/sts-a360-reg-step2-username-post.model';
import StsA360RegistrationResponseModel from '../models/sts-a360-registration-response.model';
import { StsErrorResponse } from '../models/sts-error-response';
import { StsHttpService } from './sts-http.service';
import { StsCaptcha } from 'app/models/sts-captcha.model';
import { BehaviorSubject  } from 'rxjs';
import StsA360NotificationTokenModel from '../models/sts-a360-notification-token.model';

@Injectable()
export class StsA360RegServicesService {

  private _questionsStep1: StsA360RegStep1QuestionsModel[];

  constructor(private http: StsHttpService) {
    this._questionsStep1 = null;
  }

  public getStep1Questions(): Observable<StsA360RegStep1QuestionsModel[]> {
    return new Observable<StsA360RegStep1QuestionsModel[]>(o => {
      if (this._questionsStep1 != null) {
        o.next(this._questionsStep1);
        o.complete();
      } else {
        let key = '/api/reg/step1/questions';
        this.http.get<StsA360RegStep1QuestionsModel[]>(key).subscribe(
          (q: StsA360RegStep1QuestionsModel[]) => {
            if (q) { this._questionsStep1 = q; }
            // console.log(q);
            o.next(q);
            o.complete();
          });
      }
    });
  }

  public postStep1Answers(answers: StsA360RegStep1AnswersModel):
    Observable<StsA360RegistrationResponseModel> {
    return new Observable<StsA360RegistrationResponseModel>(o => {
      let url = '/api/reg/step1/register';
      this.http.post<StsA360RegistrationResponseModel>(url, answers).subscribe(
        (q: StsA360RegistrationResponseModel) => {
          o.next(q);
          o.complete();
        }, err => {
          console.log(err);
          o.next(null);
          o.complete();
        });
    });
  }

  private messageSource = new BehaviorSubject<StsA360NotificationTokenModel>({ID:'',NotificationID:'', PersonalEmail:'', Email:'', Phone:'',ContactId:'', PreferredChannel:'email', AllowUsernameAsUniqueId:false, UserName: '', PostMfaRedirect: ''});

  currentMessage = this.messageSource.asObservable();

  changeMessage(message: StsA360NotificationTokenModel) {
    this.messageSource.next(message)
  }


  public validateOneTimeCode(id: string, clientCode: string, //"Mail2FA"
    PIN: string, //"23234u63746"
    referenceNumber: string): Observable<StsA360RegistrationResponseModel> {
    return new Observable<StsA360RegistrationResponseModel>(o => {
      let url = '/api/reg/verificationonetimecode/validation';
      this.http.post<StsA360RegistrationResponseModel>(url, {
        id: id,
        ClientCode: clientCode,
        PIN: PIN,
        referenceNumber: referenceNumber
      }).subscribe(
        (q: StsA360RegistrationResponseModel) => {
          o.next(q);
          o.complete();
        }, err => {
          console.log(err);
          o.next(null);
          o.complete();
        });
    });
  }

  public setCommunicationCahnnel(id: string, clientCode: string,
    channel: string,
    referenceNumber: string): Observable<StsA360RegistrationResponseModel> {
      return new Observable<StsA360RegistrationResponseModel>(o => {
        let url = '/api/reg/setcommunicationcahnnel';
        this.http.post<StsA360RegistrationResponseModel>(url, {
          id: id,
          ClientCode: clientCode,
          channel: channel,
          referenceNumber: referenceNumber
        }).subscribe(
          (q: StsA360RegistrationResponseModel) => {
            o.next(q);
            o.complete();
          }, err => {
            console.log(err);
            o.next(null);
            o.complete();
          });
      });
  }

  public getPersonalEmail(id: string):
  Observable<StsA360RegistrationResponseModel> {
    return new Observable<StsA360RegistrationResponseModel>(o => {

        let url = '/api/reg/personalemail';
        this.http.post<StsA360RegistrationResponseModel>(url,
          {id:'',
          notificationId:id}
        ).subscribe(
          (q: StsA360RegistrationResponseModel) => {
            o.next(q);
            o.complete();
          });
      });
    }

  public wrongPostalCode(notificationToken: StsA360NotificationTokenModel):
    Observable<StsA360RegistrationResponseModel> {
    return new Observable<StsA360RegistrationResponseModel>(o => {
      let url = '/api/reg/step1/wrongpostalcode';
      this.http.post<StsA360RegistrationResponseModel>(url,
        {id:notificationToken.ID,
          notificationId:notificationToken.NotificationID}
        ).subscribe(
        (q: StsA360RegistrationResponseModel) => {
          o.next(q);
          o.complete();
        }, err => {
          console.log(err);
          o.next(null);
          o.complete();
        });
    });
  }


  public checkAllowedEmailFormat(email: string, id: string):
    Observable<StsA360RegistrationResponseModel> {
    return new Observable<StsA360RegistrationResponseModel>(o => {

      let url = '/api/reg/step2/validate/email';
      if (!email) {
        let q = new StsA360RegistrationResponseModel();
        q.success = false;
        q.stsCode = 'sts-invalid-email';
        q.errors = ['email cannot be blank'];
        o.next(q);
        o.complete();
        return;
      }
      this.http.post<StsA360RegistrationResponseModel>(url, {
        email: email, id: id
      }).subscribe(
        (q: StsA360RegistrationResponseModel) => {
          o.next(q);
          o.complete();
        });
    });
  }

  public postStep2Answers(answers: StsA360RegStep2UsernamePostModel):
    Observable<StsA360RegistrationResponseModel> {
    return new Observable<StsA360RegistrationResponseModel>(o => {
      let url = '/api/reg/step2/register';
      this.http.post<StsA360RegistrationResponseModel>(url, answers).subscribe(
        (q: StsA360RegistrationResponseModel) => {
          o.next(q);
          o.complete();
        });
    });
  }

  public postEmployerValidationLoad(key1: string, key2: string,
                                    code: string, captcha: StsCaptcha):
    Observable<StsErrorResponse> {
    return new Observable<StsErrorResponse>(o => {
      let url = '/api/reg/employers/validate/load';
      this.http.post<StsErrorResponse>(url, {
        p1: key1,
        p2: key2,
        captcha: captcha,
        code: code
      }).subscribe(
        (q: StsErrorResponse) => {
          o.next(q);
          o.complete();
        }, (err: StsErrorResponse) => {
          console.log(err);
          o.next(err);
          o.complete();
        });
    });
  }


  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return throwError(errMsg);
  }

}
